type FinanceComingSoonPageProps = {
  title: string;
  description?: string;
};

export function FinanceComingSoonPage({ title, description }: FinanceComingSoonPageProps) {
  return (
    <div className="space-y-4 p-6 sm:p-8">
      <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-slate-950/40">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-xl font-semibold text-slate-900 dark:text-white">{title}</h1>
          <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600 dark:bg-slate-800 dark:text-slate-300">
            Coming soon
          </span>
        </div>
        {description ? (
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{description}</p>
        ) : null}
        <p className="mt-4 text-sm text-slate-600 dark:text-slate-400">
          This module is not part of the Phase 1 Books path (account → invoice → payments received). Use
          Sales accounts, invoices, and payments received for live workflows.
        </p>
      </div>
    </div>
  );
}
